import {Component, Input, OnInit, AfterViewInit, ViewChild, ElementRef} from '@angular/core';

@Component({
    selector: 'copyfield',
    templateUrl: './output.copyfield.component.html'
})
export class CopyfieldComponent implements OnInit {
    /**
     * The visible value
     */
    @Input() value: string;

    /**
     * the value that should be copied
     * @type {null}
     */
    @Input() copyValue: string = null;

    /**
     * visible label
     */
    @Input() label: string;

    /**
     * Dom Element with the infotext
     */
    @ViewChild('copyfieldInfo', { static: true }) copyfieldInfo: ElementRef;

    /**
     * margin for the result text
     * @type {string}
     */
    marginLeft: string = "0";

    /**
     * Some translationkeys that we use
     * @type {string}
     */
    static copyInfoDefaultKey: string = "copyfield.info.copy";
    static copyInfoCopiedKey: string = "copyfield.info.copied";

    /**
     * Holds the translationkey for the hint overlay
     * @type {string}
     */
    copyInfo: string = "";

    /**
     * Method is called when initializing the component
     */
    public ngOnInit(): void {
        this.copyInfo = CopyfieldComponent.copyInfoDefaultKey;
        if(this.copyValue == null) {
            this.copyValue = this.value;
        }
    }

    /**
     * Updates the margin of the info overlay so it is centered
     */
    setMarginOfInfoText(): void {
        this.marginLeft = ((this.copyfieldInfo.nativeElement.offsetWidth / 2) * -1) + "px";
    }

    /**
     * method that is called after the component has initialized
     */
    public copyText(): void {
        let that = this;

        // copy the text
        let result = this.copyTextToClipboard(this.copyValue);

        if(result == true) {
            // show ok message to the user
            this.copyInfo = CopyfieldComponent.copyInfoCopiedKey;
            window.setTimeout(function() {
                that.setMarginOfInfoText();
            }, 0);

            // reset to the old message after a few seconds
            window.setTimeout(function() {
                that.copyInfo = CopyfieldComponent.copyInfoDefaultKey;
                window.setTimeout(function() {
                    that.setMarginOfInfoText();
                }, 0);
            }, 2000);
        }
    }

    /**
     * Helper function to copy a specific text to the browsers clipboard
     * @param text
     * @returns {boolean}
     */
    private copyTextToClipboard(text): boolean {
        let txtArea = document.createElement("textarea");

        txtArea.style.position = 'fixed';
        txtArea.style.top = '0';
        txtArea.style.left = '0';
        txtArea.style.opacity = '0';
        txtArea.value = text;
        document.body.appendChild(txtArea);
        txtArea.select();
        try {
            let successful = document.execCommand('copy');
            let msg = successful ? 'successful' : 'unsuccessful';
            console.log('Copying text command was ' + msg);
            document.body.removeChild(txtArea);
            if(successful){
                return true;
            }
        }
        catch (err) {
            console.log('Oops, unable to copy');
        }
        document.body.removeChild(txtArea);
        return false;
    }
}
